import React, { useEffect, useState } from 'react';
import api from '../api';

const Settings = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get('/settings').then(res => setConfig(res.data)).catch(err => console.error(err));
  }, []);

  if (!config) return <div>Chargement...</div>;

  return (
    <div className="stats-grid">
      <div className="glass-panel stat-card" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '0.5rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>Configuration Email (IMAP)</h3>
        <div style={{ width: '100%' }}>
          <label className="input-label">Serveur Outlook/Office365</label>
          <input className="input-field" type="text" readOnly value={config.imap_host || 'Non configuré'} />
        </div>
        <div style={{ width: '100%', marginTop: '0.5rem' }}>
          <label className="input-label">Boîte Surveillée</label>
          <input className="input-field" type="text" readOnly value={config.imap_user || 'Non configuré'} />
        </div>
      </div>

      <div className="glass-panel stat-card" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '0.5rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>Moteur IA (Ollama)</h3>
        <div style={{ width: '100%' }}>
          <label className="input-label">URL API Locale</label>
          <input className="input-field" type="text" readOnly value={config.ollama_url || 'http://localhost:11434'} />
        </div>
      </div>

      <div className="glass-panel stat-card" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '0.5rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>Licence Axonaut</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '1rem' }}>
          <div style={{ 
            width: '12px', height: '12px', borderRadius: '50%', 
            background: config.axonaut_key_configured ? 'var(--success)' : 'var(--danger)',
            boxShadow: `0 0 8px ${config.axonaut_key_configured ? 'var(--success)' : 'var(--danger)'}`
          }}></div>
          <span style={{ fontWeight: 500, color: config.axonaut_key_configured ? 'var(--success)' : 'var(--danger)' }}>
            {config.axonaut_key_configured ? 'Clé API active et détectée' : 'Clé API Manquante'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Settings;
